import React, { useContext } from 'react';
import { Flex, Layout, theme as antTheme } from 'antd';

import HeaderLogoSmall from '@totem/components/logos/headerLogoSmall';
import HeaderMenu from '@totem/components/ui_components/menus/HeaderMenu';
import OrganizationSwitcherDropdown from '@totem/components/userContext/organizationSwitch/organizationSwitcherDropdown/OrganizationSwitcherDropdown';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

import ProfileIcon from '../common/profileIcon/ProfileIcon';

import HelpDeskModal from './HelpDeskModal';

const { Header: AntDHeader } = Layout;

const Header = () => {
  const { token } = antTheme.useToken();
  const { mainMenuLocation } = useContext(UserProfileContext);

  const styles = {
    header: {
      background: token.colorBgContainer,
      padding: 0,
      position: 'relative' as const,
      overflow: 'hidden',
    },
    headerBorder: {
      position: 'absolute' as const,
      bottom: 0,
      left: 0,
      right: 0,
      height: 2,
      background: token.colorBorder,
      zIndex: 10,
      pointerEvents: 'none' as const,
    },
  };

  return (
    <AntDHeader style={styles.header}>
      <div style={styles.headerBorder} />
      <Flex
        justify={'space-between'}
        align={'center'}
        style={{ height: '100%' }}
      >
        <Flex justify={'flex-start'} align={'center'} flex={1}>
          {mainMenuLocation === 'Top' && <HeaderLogoSmall />}
          {mainMenuLocation === 'Top' && <HeaderMenu />}
          <div />
        </Flex>
        <Flex justify={'flex-end'} align={'center'}>
          <OrganizationSwitcherDropdown />
          <HelpDeskModal />
          <ProfileIcon />
        </Flex>
      </Flex>
    </AntDHeader>
  );
};

export default Header;
